import { ALGOLIA_HAS_LISTABLE_STOCK_FILTER } from 'commons/constants';

/**
 * Builds the Algolia `filters` string for the search page.
 *
 * Ready-to-ship must live in `filters` rather than `Configure.facetFilters`.
 * When a color is selected the `option_color` refinementList widget generates
 * its own `facetFilters`, which fully overrides any `facetFilters` set via
 * Configure (dropping `is_in_stock`). `filters` is an independent parameter, so
 * it ANDs with the color refinement instead of being replaced by it.
 */
const buildSearchAlgoliaConfigureFilters = ({ isReadyToShipActive } = {}) => {
  const parts = [ALGOLIA_HAS_LISTABLE_STOCK_FILTER];

  if (isReadyToShipActive) {
    parts.push('is_in_stock:true');
  }

  return parts.join(' AND ');
};

export default buildSearchAlgoliaConfigureFilters;
